export default "__VITE_ASSET__b010d40a__"